import { useEffect, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import { investorApi, vendorApi, api } from "../api/api";
import { useSelector } from "react-redux";
import Loader from "../components/common/Loader";

import ScreenContainer from "../components/common/screencontainer";
import ApartmentLayoutPage from "../components/ApartmentPlots/ApartmentLayoutPage";
import AprtmentPlotsDetails from "../components/ApartmentPlots/AprtmentPlotsDetalis";
import AprtmentPlotsOverview from "../components/ApartmentPlots/AprtmentPlotsOverView";
import { useParams, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";



const ApartmentPlotsScreen = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const apartmentIdFromSlug = slug?.split("-").pop();
  const referralCode = searchParams.get("ref");

  const [apartmentData, setApartmentData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  if ( referralCode) {
    const existingRef = localStorage.getItem("referralCode");

    if (!existingRef) {
      localStorage.setItem("referralCode", referralCode);
    }
  }
}, [referralCode]);

  useEffect(() => {
  const applyReferral = async () => {
    const storedRef = localStorage.getItem("referralCode");
    if (!isAuthenticated || !storedRef || !apartmentIdFromSlug) return;
    try {
      await vendorApi.addProjectUserMapping({
        userId: userId,
        refererId: storedRef,
        apartmentId: apartmentIdFromSlug,
      });

      localStorage.removeItem("referralCode");

    } catch (error) {
      console.error("Referral error:", error);
    }
  };

  applyReferral();
}, [isAuthenticated, userId, apartmentIdFromSlug]);

  useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  const fetchData = async () => {
    try {
      if (apartmentIdFromSlug) {
        const response = await investorApi.getApartmentPlotsById(apartmentIdFromSlug);
        if (response.status === 200) {
          setApartmentData(response.data);
        }
      }
    } catch (err) {
      console.error("ApartmentPlotsScreen error:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [apartmentIdFromSlug]);

  const layoutConfig = [
    {
      id: "ApartmentLayoutPage",
      render: () => <ApartmentLayoutPage data={apartmentData} type={3} />,
    },
    {
      id: "ApartmentPlotsDetails",
      render: () => <AprtmentPlotsDetails data={apartmentData} isAuthenticated={isAuthenticated} type={4} />,
    },
    {
      id: "AprtmentPlotsOverview",
      render: () => <AprtmentPlotsOverview data={apartmentData} type={5} />,
    },
  ];

  return (
    <ScreenContainer>
      <Helmet>
      <title>
        {apartmentData?.apartment?.ApartmentName || "Apartment Flats"} | 
      </title>

      <meta
        name="description"
        content={
          apartmentData?.apartment?.Description ||
          "Explore premium apartment plots with best amenities and location."
        }
      />

      <meta property="og:title" content={apartmentData?.apartment?.ApartmentName} />
      <meta
        property="og:description"
        content={apartmentData?.apartment?.Description}
      />
      <meta property="og:type" content="website" />

      <meta
        property="og:image"
        content={apartmentData?.[0]?.image || "/default-property.jpg"}
      />

      <meta
        property="og:url"
        content={window.location.href}
      />
    </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <Box sx={{
              display: "flex",
    flexDirection: "column",
    gap: "30px",
   padding:{xs:0,sm:1,lg:2}
        }}>
          {layoutConfig.map((section) => (
            <div
              key={section.id}
              style={{ backgroundColor: theme.background, ...styles.section }}
            >
              {section.render()}
            </div>
          ))}
        </Box>
      )}
    </ScreenContainer>
  );

};

const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    // padding: "10px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",

  },
  heading: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "24px",
    color: "#333",

  },
  loadingText: {
    fontSize: "16px",
    color: "#555",
    textAlign: "center",
    marginTop: "40px",

  },
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    // padding: "5px 20px",

  },
};

export default ApartmentPlotsScreen;